import React, { useEffect } from 'react'
import Validation from '../../components/Email-Validate/Validation'
import ValidatedEmailListing from '../../components/Email-Validate/ValidatedEmailListing'

const Index = ({ userId, setHeading, role }) => {
  const [render, setRender] = React.useState(false)
  useEffect(() => {
    if (typeof setHeading === 'function') {
      setHeading('Email Validation')
    }
  }, [])
  return (
    <div>
      <Validation userId={userId} setRender={setRender} />
      <ValidatedEmailListing render={render} role={role} userId={userId} />
    </div>
  )
}

export default Index
